/**
 * Vertaalt de uren van één dag naar dagdelen, volgens de rekenregels die de
 * organisatie heeft ingesteld (`resolveBillingRules`).
 *
 * Organisaties rekenen dit verschillend (besluit Gijs, 2026-10-28). Het Blok:
 * elk aangebroken blok van vier uur is een dagdeel, maximaal twee per dag — dus
 * 4u00 is één dagdeel en 4u15 twee. Zie docs/features/facturatie-per-deelnemer.md
 * § Wijziging 2026-10-28. De uren komen uit `presenceReportHours`; tel ze nooit
 * zelf na.
 *
 * Zonder bruikbare regels gooit deze functie een fout: een stil teruggegeven
 * getal zou op een factuur belanden.
 *
 * @param {number} hours - Uren op één dag
 * @param {import('../billing/resolveBillingRules').BillingRules} rules
 * @returns {number} Aantal dagdelen; 0 als er geen uren zijn
 */
const halfDaysForHours = (hours, rules) => {
    const method = rules?.halfDayMethod
    if (!['perStartedBlock', 'onePerDay', 'proRata'].includes(method)) {
        throw new Error(`halfDaysForHours: onbekende telwijze '${method}'`)
    }
    if (!Number.isFinite(hours) || hours <= 0) return 0

    // Een kleine marge tegen afrondingsruis: 4 uur moet 1 blok blijven.
    const raw = method === 'onePerDay' ? 1
        : method === 'perStartedBlock' ? Math.ceil(hours / rules.halfDayHours - 1e-9)
        : hours / rules.halfDayHours

    return typeof rules.maxHalfDaysPerDay === 'number' ? Math.min(raw, rules.maxHalfDaysPerDay) : raw
}

export default halfDaysForHours
